/**
 * Styled Components - Created by eduardoquintero on 17/12/20.
 */
import styled from 'styled-components'

export const Container = styled.div`
  padding-bottom: 36px;
  width: 100%;
  margin-top: -64px;
  position: relative;
  @media (max-width: 768px) {
    margin-top: -14px;
  }
`

export const CarouselContainer = styled.div`
  margin-top: 38px;
  margin-bottom: 20px;
  margin-right: 34px;
  @media (max-width: 768px) {
    margin-right: 0px;
  }
  img {
    object-fit: contain !important;
    width: 100% !important;
    border-radius: 3px !important;
  }
  & .slick-prev {
    margin-left: 30px;
  }
  & .slick-next {
    margin-right: 20px;
  }
  .slick-dots {
    bottom: 25px;
    li {
      button {
        opacity: 0.6;
        background: none !important;
      }
      button:before {
        opacity: 1;
        color: #e7e7e7;
        filter: drop-shadow(0px 0px 1px white);
        font-size: 12px !important;
      }
      &.slick-active {
        button {
          opacity: 1;
          color: #3e3d3d !important;
        }
      }
    }
  }
`

export const FAQSection = styled.div`
  text-align: center;
  margin-right: 28px;
  @media (max-width: 767px) {
    margin-right: 0;
  }
`

export const FAQBody = styled.div`
  text-align: left;
  font-size: 15px;
  margin-bottom: 54px;
  b {
    display: block;
  }
`

export const FaqTitle = styled.div`
  font-weight: bold;
  margin-bottom: 28px;
  font-size: 18px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProDesignProjectsAbout/styledComponents.tsx